import { inviteConstants as ic } from './constants'
import { objectMap, commonProperties } from 'srcReact/helpers/utils'

const initialState = {
  loading: false,
  success: false,
  error: '',
  data: null
}

export function invite(state = initialState, action) {
  switch (action.type) {
    case ic.INVITE_NON_WP_MEMBERS_REQUEST:
    case ic.INVITE_TO_WORKPLACE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false
      }
    case ic.INVITE_NON_WP_MEMBERS_SUCCESS:
    case ic.INVITE_TO_WORKPLACE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      }
    case ic.INVITE_NON_WP_MEMBERS_FAILURE:
    case ic.INVITE_TO_WORKPLACE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false
      }

    default:
      return state
  }
}
